import { Space, Tag, Typography } from 'antd';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CreateTicketFormValues } from '../../../../../../../types/form';
import { TicketSystemFieldsKeyMap } from '../../../../../../model/types';
import { parseUserFriendlyValueFromUserValue } from '../../../../../../utils/forms/formHelper.parser';
import EmailCcSection from './EmailCcSection';

export default function DistributionListSection() {
    const { t } = useTranslation('tickets');
    const watchRequester = useWatch<CreateTicketFormValues, `fields.${typeof TicketSystemFieldsKeyMap.requester}`>({
        name: `fields.${TicketSystemFieldsKeyMap.requester}`
    });

    const distributionListEmail = watchRequester
        ? parseUserFriendlyValueFromUserValue(watchRequester.toString())
        : null;

    const isDistributionListEmailAvailable = distributionListEmail && distributionListEmail !== '-';

    return (
        <Space style={{ width: '70%' }} direction="vertical" size={3}>
            <Space className="full-width">
                <Typography.Text>{`${t('to')}:`}</Typography.Text>

                {watchRequester ? (
                    <Tag>{isDistributionListEmailAvailable ? distributionListEmail : watchRequester}</Tag>
                ) : (
                    <Typography.Text disabled>{t('addRequester')}</Typography.Text>
                )}
            </Space>

            <EmailCcSection />
        </Space>
    );
}
